import React from 'react';
import { t } from 'i18next';
import { SidePanel, SidePanelProps } from '@brighterionai/br-ui';
import { useAppStore } from 'Store';
import SidePanelContent from './SidePanelContent/SidePanelContent';

import styles from './ImportExportSidePanel.css';

const ImportExportSidePanel = () => {
    const { isSidePanelOpen, toggleSidePanel } = useAppStore();
    const children = <SidePanelContent />;

    const importExportQueueProps: SidePanelProps = {
        closeModal: toggleSidePanel,
        modal: {
            id: 'importExportQueue',
            name: 'import-export-queue',
            title: t('Background processes')
        },
        options: {
            isOpen: isSidePanelOpen,
            customStatusIcon: 'cloud-arrow-down-outline',
            showCloseIcon: true
        },
        children
    };

    return (
        <>
            <SidePanel {...importExportQueueProps} modalClassName={styles.importExportQueuePanel} />
        </>
    );
};

export default ImportExportSidePanel;
